module.exports = __webpack_public_path__ + "static/media/conan-bg.fca617f4.jpg";